/**
 * Register font-awesome icons
 */
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faGithub,
  faRebel,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons'
import {
  faCar,
  faChevronCircleRight,
  faCircleNotch,
  faFilm,
  faGenderless,
  faGlobe,
  faHome,
  faInfoCircle,
  faMars,
  faRobot,
  faSadTear,
  faSpaceShuttle,
  faTransgenderAlt,
  faUser,
  faVenus,
} from '@fortawesome/pro-regular-svg-icons'
import {
  faCircle,
  faExclamationTriangle,
  faSortDown,
  faSortUp,
} from '@fortawesome/pro-solid-svg-icons'

library.add(
  // Brands
  faGithub,
  faRebel,
  faTwitter,

  // Regular
  faCar,
  faChevronCircleRight,
  faCircleNotch,
  faFilm,
  faGenderless,
  faGlobe,
  faHome,
  faInfoCircle,
  faMars,
  faRobot,
  faSadTear,
  faSpaceShuttle,
  faTransgenderAlt,
  faUser,
  faVenus,

  // Solid
  faCircle,
  faExclamationTriangle,
  faSortDown,
  faSortUp,
)
